var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"inherit"}},[(_vm.errorPage)?_c(_vm.errorPage,{tag:"component",attrs:{"payload":_vm.payload}}):_c('router-view'),_vm._v(" "),_vm._l((_vm.modals),function(modal){return [_c(modal.component,_vm._b({key:modal.id,tag:"component"},'component',modal,false))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }